import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'roomservice',
      [RoomServiceLocationType.TableService]: 'bordservice',
    },
    [ORDER_METHODS.PICKUP]: 'afhentning',
    [ORDER_METHODS.DELIVERY]: 'levering',
  },
  errors: {
    draft_validation_failed: 'Udfyld din leveringsadresse, før du fortsætter.',
  },
};
